import http from '@/communication/AuthConnection'

export default async (form) => {
  try {
    const responsePayload = await http.post('v1/distributor/change-distributor', form)
    return responsePayload.data
  } catch (e) {
    return Promise.reject(new Error('ok'))
  }
}



// WEBPACK FOOTER //
// ./src/brain/record/distributor/chanage-distributor/index.js